<template>
    <client-page>
        <div class="client-content-wrap">
            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="client-title--xxxl">연혁</h2>
                    </div>

                    <ul class="history-list">
                        <li v-for="(history, index) in histories" :key="index">
                            <v-row class="row--xxl">
                                <v-col cols="12" lg="6" :order-lg="(index + 1) % 2 !== 0 ? '2' : ''">
                                    <v-row class="row--xs">
                                        <v-col cols="12">
                                            <div class="client-title--xl font-weight-bold line-height-1 history-list__year">
                                                {{ history.year }}
                                            </div>
                                        </v-col>
                                        <v-col cols="12" class="page-text page-text">
                                            <v-row v-for="item in history.items" :key="item.month" class="row--xs">
                                                <v-col cols="auto" :order-lg="(index + 1) % 2 === 0 ? '2' : ''">
                                                    <v-sheet width="20" class="grey-1--text">
                                                        {{ item.month }}
                                                    </v-sheet>
                                                </v-col>
                                                <v-col>
                                                    <v-row class="row--xs">
                                                        <v-col v-for="content in item.contents" :key="content" cols="12">
                                                            <v-row class="ma-n2">
                                                                <v-col cols="auto" class="pa-2" :order-lg="(index + 1) % 2 === 0 ? '2' : ''">·</v-col>
                                                                <v-col class="pa-2">
                                                                    {{ content }}
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" lg="6">
                                    <v-row v-if="history.images">
                                        <v-col v-for="image in history.images" :key="image" cols="6" lg="12">
                                            <v-img :src="image" max-width="384" alt="" class="history-list__image" />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </li>
                    </ul>
                </v-container>
            </section>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";

export default {
    components: {
        ClientPage,
    },
    data() {
        return {
            histories: [
                {
                    year: "2024",
                    images: [
                        "/images/about/history/24-1.jpg",
                        "/images/about/history/24-2.jpg",
                        //
                    ],
                    items: [
                        {
                            month: "01",
                            contents: [
                                "성북구 취약 계층 지원(김치 3kg 550세트 및 쌀 10kg 100포)",
                                //
                            ],
                        },
                        {
                            month: "03",
                            contents: [
                                "(사)희망그림 해외 취약계층 지원사업 업무협약",
                                "MISC 캄보디아 학교 건축 및 아동 지원사업 업무협약",
                                "유캔디오(주) 콘텐츠 생산과 교류 및 일자리 지원 업무협약",
                                //
                            ],
                        },
                        {
                            month: "04",
                            contents: [
                                "법인 산하시설장 연합 워크숍 (미래전략 논의 연수)",
                                //
                            ],
                        },
                        {
                            month: "05",
                            contents: [
                                "스리랑카•미얀마 정부 소방장비(진압헬멧 및 방화복 등) 지원",
                                "학대 피해아동 자선 패션쇼 및 콘테스트 진행",
                                //
                            ],
                        },
                        {
                            month: "06",
                            contents: [
                                "법무법인 덕수 ‘소외 아동과 노인의 권리 옹호를 위한 유산기부 법률지원’ 업무협약",
                                "용인시 학대피해아동쉼터 수탁",
                                //
                            ],
                        },
                        {
                            month: "08",
                            contents: [
                                "성북구 지역 어르신의 건강을 위한 ‘행복밥상’ 행사 개최",
                                "캄보디아 현지 NGO 3곳 협약 체결 및 사업장 방문",
                                //
                            ],
                        },
                        {
                            month: "12",
                            contents: [
                                "성북구 취약 계층 지원(김치 3kg 550세트 및 쌀 10kg 100포)",
                                "코이카 인큐베이팅 사업 선정",
                                //
                            ],
                        },
                    ],
                },
                {
                    year: "2023",
                    images: [
                        "/images/about/history/23-1.jpg",
                        "/images/about/history/23-2.jpg",
                        //
                    ],
                    items: [
                        {
                            month: "01",
                            contents: [
                                "화성시 동탄어울림종합사회복지관 수탁",
                                "FLCM 미얀마 및 해외 취약계층 지원 업무협약",
                                //
                            ],
                        },
                        {
                            month: "03",
                            contents: [
                                "GOODTV 기독교복음방송 업무 협약 진행",
                                //
                            ],
                        },
                        {
                            month: "04",
                            contents: [
                                "창립기념일 수원화성행궁 단합 걷기 진행",
                                //
                            ],
                        },
                        {
                            month: "06",
                            contents: [
                                "홍보대사 배우 권해성 위촉식 진행",
                                //
                            ],
                        },
                        {
                            month: "08",
                            contents: [
                                "국내사업기관 시설장 워크숍",
                                //
                            ],
                        },
                        {
                            month: "09",
                            contents: [
                                "성북구 어르신의 건강을 위한 행복 밥상 나눔행사 진행",
                                //
                            ],
                        },
                        {
                            month: "10",
                            contents: [
                                "노사발전재단 ‘노사파트너십 프로그램 지원사업’ 선정",
                                "노사협의회 활성화 및 노사 비전수립 워크숍 진행",
                                //
                            ],
                        },
                        {
                            month: "11",
                            contents: [
                                "노사협의회 시설장/중간관리자 간담회",
                                "노사협의회 ‘노사 소통활성화 활동’",
                                "노사협의회 ‘노사가 함께하는 김장나눔행사 활동’",
                                //
                            ],
                        },
                        {
                            month: "12",
                            contents: [
                                "취약 계층 지원을 위한 김치 3kg 550세트 및 쌀 10kg 100포 성품 전달 (성북구청)",
                                "성북구청장 감사장 수상",
                                "광명시아동보호전문기관 수탁",
                                "오산대학교 업무 협약 진행(전문인재 양성을 위한 산하 협력)",
                                //
                            ],
                        },
                    ],
                },
                {
                    year: "2022",
                    images: [
                        "/images/about/history/22.jpg",
                        //
                    ],
                    items: [
                        {
                            month: "01",
                            contents: [
                                "소외계층 팥죽나눔행사(보문사 협력사업)",
                                "여성노숙인 쉼터(열린여성센터) 의류지원",
                                "저소득 시니어 겨울방한용품 지원",
                                "강남구 자곡다함께키움센터 위탁기관 선정",
                                //
                            ],
                        },
                        {
                            month: "03",
                            contents: [
                                "아동보호전문기관(경기도 광조, 파주) 추진전략 및 발전방향성 회의 진행",
                                //
                            ],
                        },
                        {
                            month: "04",
                            contents: [
                                "국내사업기관 시설장 연합 워크숍 (미래전략 논의 연수)",
                                //
                            ],
                        },
                        {
                            month: "05",
                            contents: [
                                "에듀윌ESG위원회 쌀 100포 나눔 기증식",
                                //
                            ],
                        },
                        {
                            month: "06",
                            contents: [
                                "강북구50플러스센터 위탁기관 선정",
                                "영등포구 시니어클럽 위탁기관",
                                //
                            ],
                        },
                        {
                            month: "07",
                            contents: [
                                "강남지역자활센터 위탁기관 선정",
                                //
                            ],
                        },
                        {
                            month: "10",
                            contents: [
                                "용인시 기흥노인복지관 위탁기관 선정",
                                //
                            ],
                        },
                    ],
                },
                {
                    year: "2020~2021",
                    images: [
                        "/images/about/history/20.jpg",
                        //
                    ],
                    items: [
                        {
                            month: "20",
                            contents: [
                                "어르신일자리사업 일상생활지원센터 운영",
                                //
                            ],
                        },
                        {
                            month: "21",
                            contents: [
                                "성북50플러스센터 재위탁 운영",
                                "지역혁신계획 공모사업 ‘AI로봇치매돌봄 민관네트워크사업’ 선정",
                                "서울시 제로웨이스트 공모사업 ‘자원순환교육’ 선정",
                                "광진구 구의2동키움센터 수탁",
                                "광명시니어클럽 수탁",
                                "강동구 천호2동 키움센터 수탁",
                                "서초구 학대피해아동쉼터 수탁",
                                "파주시아동보호전문기관 수탁",
                                "경기광주아동보호전문기관 수탁",
                                "지역행사 '2021 두근두근 별빛마켓(소외계층을 위한 프리마켓)' 진행",
                                "지역사회 나눔행사 '노(老)노(NO) 성북THE중년' 행사 진행",
                                //
                            ],
                        },
                    ],
                },
                {
                    year: "2010~2019",
                    items: [
                        {
                            month: "15",
                            contents: [
                                "구립대흥어린이집 위탁 운영",
                                "구립포레스타2 어린이집 위탁운영",
                                //
                            ],
                        },
                        {
                            month: "18",
                            contents: [
                                "성북시니어클럽위탁 운영",
                                "성북50플러스센터 위탁 운영",
                                //
                            ],
                        },
                        {
                            month: "19",
                            contents: [
                                "지역주민참여 축제 '이토록 멋진마을' 행사 진행",
                                "치매전문AI로봇을 통한 사회공헌활동 진행 쌀 100포 나눔 기증식",
                                //
                            ],
                        },
                    ],
                },
                {
                    year: "2001~2009",
                    items: [
                        {
                            month: "01",
                            contents: [
                                "서울시사회복지관 평가우수프로그램 선정",
                                //
                            ],
                        },
                        {
                            month: "03",
                            contents: [
                                "서초구 우면문화센터 두레쉼터 개소",
                                //
                            ],
                        },
                        {
                            month: "04",
                            contents: [
                                "구립 고은어린이집 위탁 운영",
                                //
                            ],
                        },
                        {
                            month: "07",
                            contents: [
                                "간병인 바우뫼복지문화회관 위탁 운영",
                                "재가노인복지센터 개원",
                                //
                            ],
                        },
                        {
                            month: "08",
                            contents: [
                                "에듀윌ESG위원회 쌀 100포 나눔 기증식",
                                //
                            ],
                        },
                        {
                            month: "09",
                            contents: [
                                "간병인파견 자활근로사업 실시",
                                "서울시 노인특화사업시설 지정",
                                //
                            ],
                        },
                    ],
                },
                {
                    year: "1980~2000",
                    items: [
                        {
                            month: "89",
                            contents: [
                                "사회복지법인 설립",
                                //
                            ],
                        },
                        {
                            month: "92",
                            contents: [
                                "서울시 은빛고령자취업 알선센터 위탁운영",
                                //
                            ],
                        },
                        {
                            month: "94",
                            contents: [
                                "서울시 우면사회복지관 위탁 운영",
                                //
                            ],
                        },
                        {
                            month: "95",
                            contents: [
                                "구립 우면어린이집 개원",
                                //
                            ],
                        },
                    ],
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.history-list {
    &__image {
        border-radius: 16px;
    }
    &__year {
        position: relative;
        &::before {
            content: "";
            position: absolute;
            top: 50%;
            left: -16px;
            transform: translateY(-50%);
            width: 8px;
            height: 8px;
            background-color: var(--v-primary-base);
            z-index: 1;
        }
    }
    > li {
        position: relative;
        padding-left: 13px;
        padding-bottom: 50px;
        &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 46px;
            width: 1px;
            height: calc(100% - 30px);
            background-color: #d9d9d9;
        }
        &:last-child {
            &::before {
                top: 0;
                height: 46px;
            }
        }
    }
}
@media (min-width: 1024px) {
    .history-list {
        &__year {
            &::before {
                left: -43px;
            }
        }
        > li {
            padding-left: 0;
            padding-bottom: 90px;
            &:nth-child(odd) {
                .history-list__image {
                    margin-left: auto;
                }
            }
            &:nth-child(even) {
                text-align: right;
                .history-list__year {
                    &::before {
                        left: initial;
                        right: -45px;
                    }
                }
            }
            &::before {
                left: 50%;
                top: 64px;
                height: calc(100% - 36px);
            }
            &:last-child {
                &::before {
                    top: 0;
                    height: 40px;
                }
            }
        }
    }
}
</style>